export default function SellingPriceSection({
  product,
  setProduct,
  wholesale3Cad = 0,
  masterCaseWeightKg = 0,
  totalWeight = 0,
}) {
  const roundUpToHalfMinusFiveCents = (value) => {
    const num = Number(value) || 0;
    if (num <= 0) return 0;
    return Math.max(0, Math.ceil(num / 0.5) * 0.5 - 0.05);
  };

  const isBaseIngredient =
    String(product?.type || "").toLowerCase() === "ingredient" ||
    (String(product?.sku || "").startsWith("15") && !String(product?.sku || "").startsWith("10"));

  const effectiveMasterWeight =
    Number(masterCaseWeightKg) ||
    Number(product?.masterWeightKg) ||
    Number(product?.baseQuantity) ||
    Number(product?.netWeightKg) ||
    Number(product?.netWeightGkKg) ||
    Number(product?.qtySku) ||
    Number(totalWeight) ||
    0;

  const defaultPrice =
    wholesale3Cad > 0
      ? isBaseIngredient
        ? roundUpToHalfMinusFiveCents(wholesale3Cad)
        : effectiveMasterWeight > 0
        ? roundUpToHalfMinusFiveCents(Number(wholesale3Cad) / effectiveMasterWeight)
        : roundUpToHalfMinusFiveCents(wholesale3Cad)
      : 0;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-3 sm:p-6 md:p-8 min-w-0 w-full max-w-full overflow-hidden">
      <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4 sm:mb-6">
        SELLING PRICE
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 sm:gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Default Price ($ per {product.uom || "unit"})
          </label>
          <input
            type="text"
            readOnly
            className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-800 font-medium"
            value={defaultPrice > 0 ? `$${defaultPrice.toFixed(2)}` : "-"}
          />
        </div>
      </div>
    </div>
  );
}
